'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".TrackingEventsLastUpdated-module_refreshIconWrapper__J4487{display:flex;margin-left:.25rem}";
var styles = {"refreshIconWrapper":"TrackingEventsLastUpdated-module_refreshIconWrapper__J4487"};
styleInject["default"](css_248z, '189d9a22-2ce2-4fd2-91ac-512c5b7b6ed4');

exports["default"] = styles;
